import { FileText, HelpCircle, Lock } from 'lucide-react';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-100 bg-white px-4 py-3 dark:border-gray-800 dark:bg-gray-900 sm:px-6">
      <div className="flex flex-col items-center justify-between gap-2 text-xs text-gray-400 sm:flex-row">
        <span>&copy; {year} ProjectPilot AI. All rights reserved.</span>
        <div className="flex items-center gap-4">
          <span className="inline-flex items-center gap-1">
            <Lock className="h-3.5 w-3.5" /> Privacy
          </span>
          <span className="inline-flex items-center gap-1">
            <FileText className="h-3.5 w-3.5" /> Terms
          </span>
          <span className="inline-flex items-center gap-1">
            <HelpCircle className="h-3.5 w-3.5" /> Get help
          </span>
        </div>
      </div>
    </footer>
  );
}
